import actionTypes from "./actionTypes";

export const redirectToLogin = referrer => {
  return {
    type: actionTypes.REDIRECT_LOGIN,
    payload: referrer
  };
};

export const redirectToLoginFailed = err => {
  return {
    type: actionTypes.REDIRECT_LOGIN_FAILED,
    payload: err
  };
};

export const redirectToLogout = () => {
  return {
    type: actionTypes.REDIRECT_LOGOUT
  };
};

export const redirectToLogoutFailed = err => {
  return {
    type: actionTypes.REDIRECT_LOGOUT_FAILED,
    payload: err
  };
};

export const loginSuccess = () => {
  return {
    type: actionTypes.LOGIN_SUCCESS
  };
};

export const referrerRedirectFailed = err => {
  return {
    type: actionTypes.REFERRER_REDIRECT_FAILED,
    payload: err
  };
};
